/**
 * Language API service for admin interface
 * Handles fetching language options for multi-language support
 */

import type { Language } from '@musedrops/shared';
import {
  getAllLanguages,
  getLanguage as fetchLanguage,
  listLanguages,
} from '../data/language';

export class LanguageApi {
  static async getAll(): Promise<Language[]> {
    const { data } = await listLanguages();
    return data;
  }

  static async getByKey(key: string): Promise<Language> {
    return fetchLanguage(key);
  }
}

// Export for backwards compatibility
export const getLanguages = getAllLanguages;
